import { connect } from 'react-redux';
// import informationModule from 'app/store/information';
import familyFilmClubModule from 'app/store/familyFilmClub';
import FamilyFilmClub from './FamilyFilmClub.component';

// const { familyFilmClubRequest, setFamilyFilmClubContent } = informationModule.actions;
const { requestFamilyFilmClub } = familyFilmClubModule.actions;
const mapStateToProps = ({ familyFilmClub, user:{user} }) => (
  {
  content: familyFilmClub.content,
  user: {
    memberLevelId: user?.memberLevelId,
  }
});

const mapDispathToProps = {
  fetchContent: requestFamilyFilmClub,
  // clearState: setFamilyFilmClubContent.bind(null, null)
};

export default connect(
  mapStateToProps,
  mapDispathToProps
)(FamilyFilmClub);
